export const statisticsPages = {
  root: 'Statistics',
  newRoot: 'NewStatistics',
  active: 'active',
  chargeable: 'chargeable',
  expired: 'expired',
  immediate: 'immediate',
  retry: 'retry',
  lifetime: 'lifetime',
  all: 'all',
};

const { active, chargeable, expired, immediate, retry, lifetime, all } =
  statisticsPages;

export const statisticsPagesReg = `:page(${active}|${chargeable}|${expired}|${immediate}|${retry}|${lifetime}|${all})?`;
